import { IMasterObjectRequest } from "./LOVColumn";

export interface IRequiresMasterObject {
    //registerEventListener(type: "masterObjectRequest", listener: (ev: IMasterObjectRequest) => any, customId?: string): void;
    registerEventListener(type: string, listener: (ev: Event) => any, customId?: string): void;

    addEventListener(type: "masterObjectRequest", listener: (ev: IMasterObjectRequest) => any, useCapture?: boolean): void;
    addEventListener(type: string, listener: EventListenerOrEventListenerObject, useCapture?: boolean): void;

    requiresMasterObject: boolean; // pouze pomocná property, jinak by nešlo rozhraní identifikovat
}

export class IRequiresMasterObject {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            typeof instance.registerEventListener === "function" &&
            typeof instance.addEventListener === "function" &&
            Reflect.has(instance, "requiresMasterObject");
    }
}
